import { api } from '@/lib/api';
import type {
  PostgresLogsResponse,
  PostgresProfilerSettingsResponse,
  PostgresSlowQueriesFilters,
  PostgresSlowQueriesResponse,
} from './types';

export async function getPostgresProfilerSettings(): Promise<PostgresProfilerSettingsResponse> {
  return api.get<PostgresProfilerSettingsResponse>('/v4/postgres-profiler/settings');
}

export async function getPostgresSlowQueries(
  filters: PostgresSlowQueriesFilters,
): Promise<PostgresSlowQueriesResponse> {
  const params: Record<string, unknown> = { ...filters };
  return api.get<PostgresSlowQueriesResponse>('/v4/postgres-profiler/slow-queries', params);
}

export async function getPostgresLogs(params: {
  limit?: number;
  tailBytes?: number;
}): Promise<PostgresLogsResponse> {
  return api.get<PostgresLogsResponse>('/v4/postgres-profiler/logs', params);
}
